import { createI18n } from "vue-i18n";

const language = window.$getCookie("language");

export default createI18n({
  locale: language || "pt",
  fallbackLocale: "pt",
  enableInSFC: true,
});
